import { useEffect, useRef, useState } from "react";

interface TurnstileApi {
  render: (container: HTMLElement, config: {
    sitekey: string;
    action: string;
    theme: "light";
    size: "normal" | "compact";
    callback: (token: string) => void;
    retry: "auto";
    "refresh-expired": "auto";
    "refresh-timeout": "auto";
    "timeout-callback": () => void;
    "expired-callback": () => void;
    "error-callback": () => void;
  }) => string;
  remove: (widgetId: string) => void;
}

function turnstile(): TurnstileApi | undefined {
  return (window as Window & { turnstile?: TurnstileApi }).turnstile;
}

export function LoginTurnstile({ siteKey, onToken }: { siteKey: string; onToken: (token: string) => void }) {
  const container = useRef<HTMLDivElement>(null);
  const callback = useRef(onToken);
  const [message, setMessage] = useState("");
  useEffect(() => { callback.current = onToken; }, [onToken]);
  useEffect(() => {
    let widgetId: string | undefined;
    let active = true;
    const render = () => {
      if (!active || widgetId || !container.current || !turnstile()) return;
      widgetId = turnstile()!.render(container.current, {
        sitekey: siteKey,
        action: "bom_login",
        theme: "light", retry: 'auto', 'refresh-expired': 'auto', 'refresh-timeout': 'auto',
        size: container.current.clientWidth < 300 ? "compact" : "normal",
        callback: (token) => { callback.current(token); setMessage(""); },
        "expired-callback": () => { if (active) { callback.current(""); setMessage(""); } }, "timeout-callback": () => { if (active) { callback.current(""); setMessage(""); } },
        "error-callback": () => { if (active) { callback.current(""); setMessage(""); } },
      });
    };
    let script = document.querySelector<HTMLScriptElement>("#bom-turnstile-script");
    if (!script) {
      script = document.createElement("script");
      script.id = "bom-turnstile-script";
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      document.head.appendChild(script);
    }
    script.addEventListener("load", render);
    const unavailable = () => { if (active) setMessage("Chưa tải được xác minh bảo mật. Vui lòng tải lại trang để thử lại."); };
    script.addEventListener("error", unavailable);
    const timeout = window.setTimeout(() => { if (!widgetId) unavailable(); }, 15000);
    render();
    return () => {
      active = false;
      script?.removeEventListener("load", render);
      script?.removeEventListener("error", unavailable);
      window.clearTimeout(timeout);
      if (widgetId) turnstile()?.remove(widgetId);
    };
  }, [siteKey]);
  return <div aria-live="polite"><div ref={container} className="login-turnstile" aria-label="Xác minh bảo mật" />{message && <p role="alert" className="form-error">{message}</p>}</div>;
}
